export const SHOW_SUBSIDY = 'SHOW_SUBSIDY';
export const HIDE_SUBSIDY = 'HIDE_SUBSIDY';
